"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideObj = void 0;
class SlideObj {
    constructor() {
        this.pageNum = 0; // matches pages/<pageNum>/ folder
        this.sound = ""; // filename only, e.g. "1.mp3"
        this.caption = "";
        this.voices = {}; // MC name → audio path
    }
}
exports.SlideObj = SlideObj;
